import React, { Component } from 'react';
import axios from 'axios';
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { Alert } from "@material-ui/lab";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import Row from 'react-bootstrap/Row'
import Button from "react-bootstrap/Button";
import { Paper } from "@material-ui/core";
import moment from "moment";

class StudentInfoForm extends Component {

  constructor(props) {
    super(props);
    if (!props.submitFunction) {
      throw new Error('submitFunction must be imlpemented');
    }
    this.state = {
      students: null,
      studentsLoaded: false,
      email_error: false, //used for toast error handling if email exists
      lcfID_error: false, //used for toast error handling if LCF ID exists
      error: false,
      retrieveError: false,

      // form fields state
      first_name: "",
      last_name: "",
      grade: "",
      grad_year: "",
      school_attend: "",
      lcf_id: "",
      lcf_start_date: "",
      savings: "existing student",
      student_email: "",
      password: "",
      pif_amount: "",
    };
  }

  componentDidMount() {
    axios.get(`/api/student/studentlist`)
      .then((res) => {
        if (this.props.lcf_id_original) {
          const rm_idx = res.data.findIndex((e) =>{
            return e.lcf_id === this.props.lcf_id_original;
          });
          const origStudent = res.data[rm_idx];
          res.data.splice(rm_idx, 1);
          this.setState(origStudent);
          this.setState({lcf_start_date:
            moment.utc(origStudent.lcf_start_date).format("YYYY-MM-DD")});
        }
        this.setState({
          students: res.data,
          studentsLoaded: true
        });
      })
      .catch((e) => {
        this.setState({retrieveError: true});
        console.log('failed to retrieve student info', e);
      });


  }

  render() {
    if (this.state.retrieveError) {
      return (
      <Alert className="error" style={{}} severity="error">
        Failed to load existing emails/IDs. Please try again later.
      </Alert>
      );
    }

    if (!this.state.studentsLoaded) {
      return (
        <div style={{ 'textAlign': 'center' }}>Loading...</div>
      );
    }

    return (
      <>
        {this.state.email_error === true && (
          <Alert className="error" style={{}} severity="error">
            The email you entered already exists in the system, pick a new one!
          </Alert>
        )}
        {this.state.lcfID_error === true && (
          <Alert className="error" style={{}} severity="error">
            The LCF ID you chose already exists in the system, pick a new one!
          </Alert>
        )}
        {this.state.error === true && (
          <Alert className="error" style={{}} severity="error">
            Please fill out all of the required fields
          </Alert>
        )}
        <Paper
            elevation={5}
            style={{ width: "90%", margin: "3% auto", padding: "2%" }}
          >
          <Form className="addstudent">
            <Row>
              <Col>
                <Form.Label>First Name</Form.Label>
                <Form.Control
                  placeholder="First Name"
                  type="text"
                  name="first_name"
                  value={this.state.first_name}
                  onChange={this.handleInputChangeFor("first_name")}
                />
              </Col>

              <Col>
                <Form.Label>Last Name</Form.Label>
                <Form.Control
                  placeholder="Last Name"
                  type="text"
                  name="last_name"
                  value={this.state.last_name}
                  onChange={this.handleInputChangeFor("last_name")}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Label>Grade</Form.Label>
                <Form.Control
                  value={this.state.grade}
                  as="select"
                  onChange={(event) =>
                    this.setState({ grade: event.target.value })
                  }
                >
                  <option value="">Pick From Below</option>
                  <option value="6">6</option>
                  <option value="7">7</option>
                  <option value="8">8</option>
                  <option value="9">9</option>
                  <option value="10">10</option>
                  <option value="11">11</option>
                  <option value="12">12</option>
                </Form.Control>
              </Col>
              <Col>
                <Form.Label>Graduation Year</Form.Label>
                <Form.Control
                  placeholder="Enter Graduation Year"
                  type="number"
                  name="grad_year}"
                  min={new Date().getFullYear()}
                  value={this.state.grad_year}
                  onChange={this.handleInputChangeFor("grad_year")}
                />
              </Col>
              <Col>
                <Form.Label>School Name</Form.Label>
                <Form.Control
                  placeholder="School Name"
                  type="text"
                  name="school_attend"
                  value={this.state.school_attend}
                  onChange={this.handleInputChangeFor("school_attend")}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Label>LCF ID:</Form.Label>
                <Form.Control
                  placeholder="Enter LCF ID"
                  type="number"
                  name="lcf_id"
                  value={this.state.lcf_id}
                  onChange={this.handleInputChangeFor("lcf_id")}
                />
              </Col>
              <Col>
                <Form.Label>LCF Start Date</Form.Label>
                <Form.Control
                  placeholder="LCF Start Date"
                  type="date"
                  name="lcf_start_date"
                  value={this.state.lcf_start_date}
                  onChange={this.handleInputChangeFor("lcf_start_date")}
                />
              </Col>
              <Col>
                <Form.Label>PIF Contribution</Form.Label>
                <Form.Control
                  placeholder="PIF Contribution"
                  type="number"
                  name="pif_amount"
                  value={this.state.pif_amount}
                  onChange={this.handleInputChangeFor("pif_amount")}
                />
              </Col>
              {(this.props.newStudent === true) && (<Col>
                <Form.Label>Previous Savings</Form.Label>
                <Form.Control
                  placeholder="Previous Savings"
                  type="number"
                  name="savings"
                  value={this.state.savings}
                  onChange={this.handleInputChangeFor("savings")}
                />
              </Col>)}
            </Row>
            <Row>
              <Col>
                <Form.Label>Student Email</Form.Label>
                <Form.Control
                  placeholder="Student Email"
                  type="email"
                  name="student_email"
                  value={this.state.student_email}
                  onChange={this.handleInputChangeFor("student_email")}
                />
              </Col>
              {(this.props.newStudent === true) && (<Col>
                <Form.Label>Student Password</Form.Label>
                <Form.Control
                  placeholder="Student Password"
                  type="text"
                  name="password"
                  value={this.state.password}
                  onChange={this.handleInputChangeFor("password")}
                />
              </Col>)}
            </Row>

            <center>
              <Button
                onClick={(event) => this.validateAndSubmit(event)}
                variant="success"
                type="submit"
                style={{ width: "20%", marginTop: "2%" }}
              >
                {this.props.newStudent ? "Create New Student"
                : "Update Student"}
              </Button>
            </center>
          </Form>
        </Paper>
      </>
    );
  }

  //This function handles storing input values into state on change
  handleInputChangeFor = (propertyName) => (event) => {
    this.setState({
      [propertyName]: event.target.value,
    });
  };

  validateAndSubmit = (event) => {
    event.preventDefault();
    // validate all form fields exist
    if (!(
      this.state.first_name &&
      this.state.last_name &&
      this.state.grade &&
      this.state.grad_year &&
      this.state.school_attend &&
      this.state.lcf_id &&
      this.state.lcf_start_date &&
      this.state.student_email &&
      this.state.password &&
      this.state.pif_amount
    )) {
      this.setState({error: true});
      setTimeout(() => {
        this.setState({error: false})
      }, 5000);
      return;
    }

    // validate against existing emails
    let existingIdx = this.state.students.findIndex((e) => {
      return e.student_email === this.state.student_email;
    });
    if (existingIdx > -1) {
      this.setState({email_error: true});
      setTimeout(() => {
        this.setState({
          email_error: false,
        });
      }, 5000);
      return;
    }
    
    // validate against existing lcf_id's
    existingIdx = this.state.students.findIndex((e) => {
      return e.lcf_id === parseInt(this.state.lcf_id);
    });
    if (existingIdx > -1) {
      this.setState({lcfID_error: true});
      setTimeout(() => {
        this.setState({
          lcfID_error: false,
        });
      }, 5000);
      return;
    }

    this.props.submitFunction({
      first_name: this.state.first_name,
      last_name: this.state.last_name,
      grade: this.state.grade,
      grad_year: this.state.grad_year,
      school_attend: this.state.school_attend,
      lcf_id: this.state.lcf_id,
      lcf_start_date: this.state.lcf_start_date,
      savings: this.state.savings,
      student_email: this.state.student_email,
      password: this.state.password,
      pif_amount: this.state.pif_amount
    });

  }
}

const mapStateToProps = (state) => ({

});

export default withRouter(connect(mapStateToProps)(StudentInfoForm));
